/* TE specific JS */

function RenderHtmlIntoControl(html, controlId, slowTransition) {
    Global_RenderHtmlIntoControl(html, controlId, slowTransition, true);
}

function ClearSytemMessagesWithTimeout() {
    setTimeout(function () {
        if ($("#ValidationInfoContainer").length > 0) {
            $("#ValidationInfoContainer").empty();
        } }, 2000);
}
